<template>
    <component :is="'style'">
        {{ estiloCSS }}
    </component>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    fontSize: String,
    componenteId: String,
    texto: String,
});

const TAMANHOS_PADRAO_HEADING = {
    h1: 32,
    h2: 24,
    h3: 18.72,
};

const FONTES_MAP = {
    'ql-font-serif': '"Georgia", "Times New Roman", serif',
    'ql-font-monospace': '"Monaco", "Courier New", monospace',
};

const estiloCSS = computed(() => {
    const tamanhoFonteProp = parseFloat(props.fontSize);
    let css = '';

    // Lógica para Font Family
    if (props.texto) {
        for (const [classe, familia] of Object.entries(FONTES_MAP)) {
            if (props.texto.includes(classe)) {
                css += `
                    [data-componente-id="${props.componenteId}"] .${classe} {
                        font-family: ${familia} !important;
                    }
                `;
            }
        }
    }

    // Lógica para Font Size
    if (isNaN(tamanhoFonteProp)) {
        return css;
    }

    css += `
        [data-componente-id="${props.componenteId}"] p {
            font-size: ${tamanhoFonteProp}px !important;
        }
    `;

    for (const [tag, tamanhoPadrao] of Object.entries(TAMANHOS_PADRAO_HEADING)) {
        if (tamanhoFonteProp > tamanhoPadrao) {
            css += `
                [data-componente-id="${props.componenteId}"] ${tag} {
                    font-size: ${tamanhoFonteProp}px !important;
                }
            `;
        }
    }

    return css;
});
</script>
